
import { defineComponent } from 'vue';

export default defineComponent({
	name: 'background-video',

	props: {
		src: {
			type: String,
			required: true
		}
	}
});
